import { createFileRoute, redirect } from '@tanstack/react-router';

// Links already handed out before the guide was renamed.
export const Route = createFileRoute('/developers_/kubicle')({
  beforeLoad: () => {
    throw redirect({ to: '/developers/quickstart', hash: location.hash.slice(1) || undefined });
  },
});
